import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";

const EditCountryComponent = loadable(
  () => import("../../components/Country/EditCountry")
);
const EditCountry = () => {
  const { id } = useParams()

  const { refetch } = useGetHook({
    queryKey: [`country-${id}`],
    url: `${APIS.LOCATION}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["Country"],
    navigateURL: "/country",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.LOCATION}${id}/`;
    let formData = {
      ...values,
      parent:null
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Country</span>
      </div>
      <EditCountryComponent
        isLoading={isPatchLoading}
        refetch={refetch}
        handleEdit={handleEdit}
      />
    </>
  );
};
export default EditCountry;
